import React from 'react';
import Button from '../button';
import { connect } from 'react-redux';
import { usersApi } from '../../../services/apis';
import { injectIntl } from 'react-intl';
import {
  flightBookingRoutes,
  profileRoutes,
} from '../../../utils/consts/routes';
import GoogleLogin from 'react-google-login';
import { updateUser } from '../../../actions/user';
import { withRouter } from '~HOC';

class LoginWithGoogle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  responseGoogle = (response) => {
    if (response.profileObj) {
      usersApi
        .googleLogin({
          username: response.profileObj.email,
          basicInfo: { googleId: response.profileObj.googleId },
          email: response.profileObj.email,
          firstName: response.profileObj.givenName,
          lastName: response.profileObj.familyName,
        })
        .then((result) => console.log('result googoolooo', result));
      // userObj = { user: Object.values(user), profiles: [] }
      // fetchAPI("users/google", "POST", {
      //   userName: response.profileObj.email,
      //   // password: "Qwsxcv!@#$/77",
      //   password: "123456",
      //   firstName: response.profileObj.givenName,
      //   lastName: response.profileObj.familyName,
      //   email: response.profileObj.email,
      //   basicInfo: {
      //     googleId: response.profileObj.googleId,
      //     imageUrl: response.profileObj.imageUrl
      //   }
      // }).then(profile => {
      //   console.log("profile===>",profile);

      // if (profile === true) {
      // this.props.updateUser(userObj);
      if (this.props.route && this.props.route.fr) {
        this.props.navigate(
          `${flightBookingRoutes.identify}?${new URLSearchParams(
            this.props.route,
          ).toString()}`,
        );
      } else this.props.navigate(profileRoutes.userBasicInfo);
      // }
      // }).catch(rej=>console.log("reject shode===>",rej))
    }
  };
  render() {
    let {
      //backgroundColor = "#b80089",
      color = 'white',
      className = 'btn-secondary',
    } = this.props;

    return (
      // please set you bussiness gmail token
      <GoogleLogin
        clientId="862892929898-e62si0q3q5q96a43n18s7ho5j81gpers.apps.googleusercontent.com"
        render={(renderProps) => (
          <Button
            name={`loginwithgoogle-button`}
            id={`loginwithgoogle-button`}
            label={this.props.intl.formatMessage({
              id: 'user.loginwithgoogle',
            })}
            onClick={renderProps.onClick}
            color={color}
            className={`w-100 py-3 py-lg-4 btn rounded ${className}`}
          />
        )}
        buttonText="Login"
        // onSuccess={this.responseGoogle}
        // onFailure={this.responseGoogle}
      />
    );
  }
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
    // notification: state.notification
  };
}
export default connect(mapStateToProps, { updateUser })(
  injectIntl(withRouter(LoginWithGoogle)),
);
